import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isDropdownVisible: boolean = false;
  showNavMenu:boolean =true;
  worklogUrl:string = "https://worklog.fr/"
  constructor() { }

  ngOnInit(): void {
    document.querySelector('.apps-view').classList.remove('.apps-view-active');
  }

  toggleDropdown(show : boolean): void {
    this.isDropdownVisible = show;//!this.isDropdownVisible;
  }

  scrollToProducts() {
    const element = document.getElementById('products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  scrollToContactSection(){
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    const target = event.target as HTMLElement;
    const container = document.querySelector('.apps-section');

    if (container && !container.contains(target)) {
      this.isDropdownVisible = false;
    }
  }

  navigate(url: string) {
    window.location.href = this.worklogUrl;
  }
  handleApps(){
    document.querySelector('.apps-view').classList.toggle('apps-view-active');
  }
  handleNavBar(){
    document.querySelector('.nav-menu').classList.toggle('nav-menu-enabled');
    document.querySelector('.apps-view').classList.remove('apps-view-active');
  }
}
